export const ORIZONTE_EASE = [0.16, 1, 0.3, 1] as const;

export const motionRegistry = [
  "app.boot.orb-settle",
  "app.route.fade-through",
  "app.command-palette.reveal",
  "app.toast.energy-rise",
  "sidebar.active-rail-slide",
  "sidebar.mobile-sheet-open",
  "sidebar.nav-icon-glow",
  "dashboard.header-mask-in",
  "dashboard.widget-stagger",
  "dashboard.kpi-roll",
  "dashboard.optimization-pulse",
  "dashboard.stack-orbs-to-list",
  "dashboard.quick-timeline-node",
  "subscription.table-row-enter",
  "subscription.row-hover-glare",
  "subscription.row-to-detail-flip",
  "subscription.filter-chip-shift",
  "subscription.search-focus-listen",
  "subscription.import-panel-rise",
  "subscription.file-scan-line",
  "subscription.import-review-check",
  "subscription.pause-depth-drop",
  "subscription.cancel-implode",
  "detail.modal-backdrop-blur",
  "detail.brand-aura-breathe",
  "detail.billing-chart-draw",
  "detail.tos-scramble-resolve",
  "calendar.thread-draw",
  "calendar.node-illumination",
  "calendar.month-group-pin",
  "calendar.high-impact-pulse",
  "analytics.area-line-draw",
  "analytics.gradient-fill-rise",
  "analytics.pie-segment-settle",
  "analytics.tooltip-crosshair-snap",
  "analytics.metric-delta-flash",
  "intelligence.card-drop",
  "intelligence.word-reveal",
  "intelligence.dismiss-gap-collapse",
  "intelligence.priority-border-trace",
  "meridian.signal-card-materialize",
  "meridian.score-count-up",
  "meridian.severity-border-pulse",
  "meridian.constellation-orbit",
  "meridian.thread-draw",
  "assistant.message-cascade",
  "assistant.card-fan-in",
  "assistant.action-magnet",
  "assistant.typing-dot-pulse",
  "settings.toggle-confirm-pulse",
  "notifications.unread-attention",
  "subscriptions.row-clip-reveal",
  "scenario.toggle-z-drop",
  "scenario.spark-transfer",
  "scenario.savings-tally-roll",
  "scenario.apply-confirm-ripple",
  "accounts.card-metal-tilt",
  "accounts.sync-spin-smooth",
  "accounts.connection-pulse",
  "accounts.error-repair-flash",
  "settings.active-tab-pill",
  "settings.slider-glow-drag",
  "settings.toggle-spring",
  "settings.billing-flag-reveal",
  "landing.hero-dashboard-tilt",
  "landing.timeline-scroll-trace",
  "landing.waitlist-modal-spring",
  "loading.skeleton-intelligence-sweep",
  "mobile.bottom-nav-rise",
  "mobile.table-row-compress",
  "mobile.chart-resize-settle",
] as const;

export type MotionName = typeof motionRegistry[number];

export const shouldReduceOrizonteMotion = () => {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
  // Reduce motion on touch/mobile devices for performance
  if (window.matchMedia("(pointer: coarse)").matches) return true;
  // Reduce motion on small screens
  if (window.innerWidth < 768) return true;
  return false;
};
